import React, { useState } from 'react';
import { Icon } from '../Icon';
import styles from './UpsellFaqV2.css';

const FAQ_ITEMS = [
    {
        question: 'Is this AI or a real person?',
        answer: 'A real human advisor — no bots, no AI chat. When you call, a real person picks up, reviews your security situation, and speaks to you directly.'
    },
    {
        question: 'Do I need to know anything technical?',
        answer: "No. You don't need to know technical details. Just describe what happened in your own words and we'll guide you through the next steps."
    },
    {
        question: 'What if nothing bad happens in 2 weeks?',
        answer: 'You can cancel anytime within the trial — no questions asked. The advisor is there for peace of mind, not just emergencies.'
    },
    {
        question: 'How do I cancel if I want to?',
        answer: 'Cancel any time in one click from your account settings. No phone calls, no forms, no hassle.'
    }
];

function UpsellFaqV2() {
    const [openIndex, setOpenIndex] = useState(0);

    const toggle = index => setOpenIndex(prev => prev === index ? -1 : index);

    return (
        <section className={styles.root}>
            <h2 className={styles.title}>Frequently Asked Questions</h2>
            <ul className={styles.list}>
                {FAQ_ITEMS.map(({ question, answer }, index) => {
                    const isOpen = openIndex === index;

                    return (
                        <li key={question} className={styles.item}>
                            <button
                                type='button'
                                className={styles.question}
                                aria-expanded={isOpen}
                                onClick={() => toggle(index)}
                            >
                                <span>{question}</span>
                                <Icon name={isOpen ? 'chevronUpLarge' : 'chevronDownLarge'} className={styles.chevron} />
                            </button>
                            {isOpen && <p className={styles.answer}>{answer}</p>}
                        </li>
                    );
                })}
            </ul>
        </section>
    );
}

export {
    UpsellFaqV2
};
